import { createActions, createReducer } from 'reduxsauce'

import ArquivosAnexosService from '../../servicos/ArquivosAnexosService'

/**
 * Action types & creators
 */
export const { Types, Creators } = createActions({
    buscaAnexosObrasParadasInicio: [],
    buscaAnexosObrasParadasSucesso: ['anexosObrasParadas'],
    buscaAnexosObrasParadasErro: ['erro'],
})

const INITIAL_STATE = {
    carregando: false,
    erro: null,
    lista: [],
}

// Ação para busca completa
Creators.buscaAnexosObrasParadas = filtro => {
    return dispatch => {
        dispatch(Creators.buscaAnexosObrasParadasInicio())
        let serv = new ArquivosAnexosService()
        return serv
            .consultarAnexosObrasParadas(filtro)
            .then(response => dispatch(Creators.buscaAnexosObrasParadasSucesso(response.data)))
            .catch(error => dispatch(Creators.buscaAnexosObrasParadasErro(error)))
    }
}

const buscaAnexosObrasParadasInicio = (state = INITIAL_STATE, action) => {
    return { ...state, carregando: true, erro: null }
}

const buscaAnexosObrasParadasErro = (state = INITIAL_STATE, action) => {
    return { ...state, erro: action.erro, carregando: false }
}

const buscaAnexosObrasParadasSucesso = (state = INITIAL_STATE, action) => {
    return { ...state, lista: action.anexosObrasParadas, carregando: false }
}

/**
 * Reducer
 */
export default createReducer(INITIAL_STATE, {
    [Types.BUSCA_ANEXOS_OBRAS_PARADAS_INICIO]: buscaAnexosObrasParadasInicio,
    [Types.BUSCA_ANEXOS_OBRAS_PARADAS_ERRO]: buscaAnexosObrasParadasErro,
    [Types.BUSCA_ANEXOS_OBRAS_PARADAS_SUCESSO]: buscaAnexosObrasParadasSucesso,
})
